import type { LikedUser } from '@wlb/shared/types/post';
import { normalizeUserGuid } from '@wlb/shared/utils/navigateToUserProfile';

export interface CurrentUserIdentity {
  userId?: string | number | null;
  userGuid?: string | null;
}

/** Matches a likes-list row to the signed-in user by either stable identity. */
export const isLikedUserCurrentUser = (
  user: Pick<LikedUser, 'id' | 'profileUserGuid' | 'userGuid'>,
  currentUser: CurrentUserIdentity,
): boolean => {
  const currentUserId =
    currentUser.userId == null ? '' : String(currentUser.userId).trim();
  if (currentUserId !== '' && String(user.id).trim() === currentUserId) {
    return true;
  }

  const currentUserGuid = normalizeUserGuid(currentUser.userGuid)?.toLowerCase();
  if (!currentUserGuid) return false;

  return (
    normalizeUserGuid(user.profileUserGuid)?.toLowerCase() === currentUserGuid ||
    normalizeUserGuid(user.userGuid)?.toLowerCase() === currentUserGuid
  );
};

/** Resolves API relationship state with an immediate modal-session override. */
export const isLikedUserFollowing = (
  user: Pick<LikedUser, 'isBuddy' | 'isFollowing'>,
  sessionOverride?: boolean,
): boolean =>
  sessionOverride ?? user.isFollowing ?? user.isBuddy;
